<mat-expansion-panel class="exp-panel" [expanded]="true" [id]="'m_' + data?.marketId?.replace('.', '_')" tabindex="-1">
  @let isMyMarket = headerType === "my-markets";
  <mat-expansion-panel-header class="exp-panel-header white-panel-indicator">
    @if (isMyMarket) {
      <app-my-markets-bf-header class="exp-panel-title" [data]="data" />
    } @else {
      <mat-panel-title class="exp-panel-title">
        <div class="market-title">
          <mat-icon class="fav-icon" [class.selected-fav]="isFavorite" (click)="handleFavorites($event)">star</mat-icon>
          <span>{{ data?.marketName }}</span>
          @if (totalMatched() >= 0) {
            &nbsp;- Matched:&nbsp;<b>{{ totalMatched() * exRateValue | number: "1.0-0" }}</b>
          }
        </div>
        @if (showStartTime) {
          <app-market-countdown [marketStartTime]="data?.marketStartTime" />
        }
      </mat-panel-title>
    }
  </mat-expansion-panel-header>
  @if (data) {
    <div class="overlay-wrapper">
      @if (data && !isLine && hasCashOut && !isAsianHandicap && showCashOut && !isDoubleChance && !isMyMarket) {
        <app-cash-out-offer [market]="data" [runnerUpdates]="runnerUpdates" />
      }
      @if (isAsianHandicap && data) {
        <app-asian-handicap-pnl [market]="data" />
      }
      <div class="m-runners">
        <app-market-runners [market]="data" [marketUpdate]="marketUpdate()" />
      </div>
      @if (marketStatus() && marketStatus() !== "Open") {
        <app-overlay [text]="marketStatus()" />
      }
      @if (!allowPlacement) {
        <app-block-overlay />
      }
    </div>
  }
</mat-expansion-panel>
